import { trigger, state, style, transition, animate } from '@angular/animations';

export const searchAnimation =
  trigger('searchAnimation', [
    state('unsearch', style({
      transform: 'translateY(-100%)'
    })),
    state('unsearchNoAnim', style({
      transform: 'translateY(-100%)'
    })),
    state('search', style({
      transform: 'translateY(0)'
    })),
    transition('* => search', [
      animate('0.5s cubic-bezier(.84,.14,.65,.96)')
    ]),
    transition('search => unsearch', [
      animate('0.5s cubic-bezier(.84,.14,.65,.96)')
    ]),
    transition('search => unsearchNoAnim', [
      animate('0s')
    ]),
  ]);

export const mobileLinksAnimation =
  trigger('mobileLinksAnimation', [
    state('hideMenu', style({
      transform: 'translateY(-100%)'
    })),
    state('showMenu', style({
      transform: 'translateY(90px)',
      height: 'calc(100vh - 90px)'
    })),
    transition('hideMenu => showMenu', [
      animate('0.5s cubic-bezier(.84,.14,.65,.96)')
    ]),
    transition('showMenu => hideMenu', [
      animate('0.5s cubic-bezier(.84,.14,.65,.96)')
    ]),
  ]);
